import { Translate } from '@chipinside/translate'
import { Alert, AlertTitle, Box, Button, Stack } from '@mui/material'

import { ccomDrawerOpen } from '#/components/Maps/Markers/CCom'
import { cenvDrawerOpen } from '#/components/Maps/Markers/CEnv'
import { farmDrawerOpen } from '#/components/Maps/Markers/Farm'
import { PortalTop } from '#/utils/portal'

type Marker = { id: number; code: string }

interface MarkerAlertProps {
  title: string
  items?: Marker[]
  onClick: any
  label: string
}

function MarkerAlert({ items, label, onClick, title }: MarkerAlertProps) {
  if (!items?.length) return null

  return (
    <Alert severity="warning">
      <AlertTitle>{title}</AlertTitle>
      <Stack direction={'row'} sx={{ flexWrap: 'wrap', gap: 0.5 }}>
        {items.map(marker => (
          <Button
            color="inherit"
            size="small"
            variant="outlined"
            key={JSON.stringify(marker)}
            onClick={() => onClick(marker)}
          >
            {marker[label]}
          </Button>
        ))}
      </Stack>
    </Alert>
  )
}

export default function MapsAlerts({ markers }: { markers: any }) {
  return (
    <PortalTop>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 1 }}>
        <MarkerAlert
          title={Translate({
            messageKey: 'item_lat_lng_invalid',
            params: { item: Translate({ messageKey: 'c_com' }) },
          })}
          items={markers.ccom}
          onClick={ccomDrawerOpen}
          label="serial"
        />
        <MarkerAlert
          title={Translate({
            messageKey: 'item_lat_lng_invalid',
            params: { item: Translate({ messageKey: 'cow_comfort' }) },
          })}
          items={markers.cenv}
          onClick={cenvDrawerOpen}
          label="code"
        />
        <MarkerAlert
          title={Translate({
            messageKey: 'item_lat_lng_invalid',
            params: { item: Translate({ messageKey: 'farm' }) },
          })}
          items={markers.farm}
          onClick={farmDrawerOpen}
          label="label"
        />
      </Box>
    </PortalTop>
  )
}
